export let svg = {
  gt: `
<svg width="0.5em" height="0.6em">
<line stroke-linecap="square" stroke="currentColor" stroke-width="1.375" x1="0" y1="0" x2="0.3em" y2="0.3em"></line>
<line stroke-linecap="square" stroke="currentColor" stroke-width="1.375" x1="0" y1="0.6em" x2="0.3em" y2="0.3em"></line>
</svg>`
}



// WEBPACK FOOTER //
// ./src/components/elements/svg.js